export default "__VITE_ASSET__01078328__"